import Hero from "@/components/Hero";
import ServicesBento from "@/components/ServicesBento";
import AboutSection from "@/components/AboutSection";
import InitiativesSpotlight from "@/components/InitiativesSpotlight";
import TrustMarquee from "@/components/TrustMarquee";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";

const Home = () => {
  return (
    <main data-testid="page-home">
      <Hero />
      <TrustMarquee />
      <ServicesBento />
      <AboutSection />
      <InitiativesSpotlight />
      <Testimonials />
      <CTASection />
    </main>
  );
};

export default Home;
